module.exports = __webpack_public_path__ + "band_1.19a0e313.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/band_1.png
// module id = 4DPQ
// module chunks = 0